import { ReactNode } from "react";
import { useAuth } from "react-oidc-context";
import NavBarHeader from "../../components/NavBarHeader/NavBarHeader";
import styles from "./Layout.module.scss";

const Layout = ({ children }: { children: ReactNode }) => {
  const { user } = useAuth();

  return (
    <>
      {user && <NavBarHeader />}
      <main className={styles.Content}>{children}</main>
    </>
  );
};

export default Layout;
